"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animation = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = require("styled-components");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  0%{\n    background-position: -", "px 0\n  }\n  100%{\n    background-position: ", "px 0\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DURATION = '1s';
var TIMING_FUNC = 'linear';
var DELAY = '0s';
var ITERATION = 'infinite';
var FILL_MODE = 'forwards';
var POSITION_X = 700;
var SHIMMER_ANIMATION = (0, _styledComponents.keyframes)(_templateObject(), POSITION_X, POSITION_X);
var animation = "\n  animation: " + SHIMMER_ANIMATION + " " + DURATION + " " + TIMING_FUNC + " " + DELAY + " " + ITERATION + " " + FILL_MODE + "\n";
exports.animation = animation;